import * as React from 'react';
export const IcPrescription = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.57 5.71c0-.42-.18-.42-.28-.42h-.96v.84h.96c.1 0 .28 0 .28-.42z'
      fill='currentColor'
    />
    <path
      d='M16.52 2H7.48A2.48 2.48 0 005 4.48v15.04A2.48 2.48 0 007.48 22h9.04A2.48 2.48 0 0019 19.52V4.48A2.48 2.48 0 0016.52 2zM7 4.62c0-.36.27-.62.64-.62H9.3c.79 0 1.6.53 1.6 1.71 0 1.08-.67 1.61-1.4 1.69l.57.85.72-1.09c.42-.53 1.21-.23 1.21.37v.12l-.08.17-1.05 1.58 1.1 1.72.03.22c0 .39-.36.66-.68.66-.21 0-.4-.11-.52-.29l-.73-1.14-.72 1.13c-.13.2-.32.3-.53.3-.32 0-.68-.27-.68-.66v-.12l.08-.18L9.28 9.4l-.94-1.38v.43c0 .37-.28.64-.67.64S7 8.82 7 8.45V4.62zM8 15h5c.55 0 1 .45 1 1s-.45 1-1 1H8c-.55 0-1-.45-1-1s.45-1 1-1zm8 5H8c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1z'
      fill='currentColor'
    />
  </svg>
);
